import * as React from "react";
import { PageHeader, DocumentTitle, Spinner } from "components/common";
import DocsHelper from "util/DocsHelper";
import FiltersOverview from "search-filter/components/filter-management-pages/UserSearchFiltersOverview/FiltersOverview";
import SearchFiltersPageSubactions from "search-filter/components/filter-management-pages/SearchFiltersPageSubactions";
import { InvalidLicenseWarning } from "license/LicenseCheck";
import useSearchFilterLicenseStatus from "search-filter/hooks/useSearchFilterLicenseStatus";
const MyFiltersOverviewPage = () => {
  const { isFetchingLicense, isValidLicense } = useSearchFilterLicenseStatus();
  if (isFetchingLicense) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: "My Filters" }, /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: "My Filters",
      actions: /* @__PURE__ */ React.createElement(SearchFiltersPageSubactions, { licenseIsValid: isValidLicense }),
      documentationLink: {
        title: "Search filter documentation",
        path: DocsHelper.PAGES.SEARCH_FILTERS
      }
    },
    /* @__PURE__ */ React.createElement("span", null, 'Overview of your "My Filters" collection. It contains all filters created by you and all filters you have the "own" permission for. All filters can be included in any search and dashboard widget by using the controls in the related search bar. Please note, changing a filter will affect all saved searches and dashboard widgets which include this filter.')
  ), isValidLicense ? /* @__PURE__ */ React.createElement(FiltersOverview, null) : /* @__PURE__ */ React.createElement(
    InvalidLicenseWarning,
    {
      featureName: "search filter",
      licenseSubject: "/license/enterprise/search-filter",
      displayWarningContainer: true
    }
  ));
};
export default MyFiltersOverviewPage;
